export default __webpack_public_path__ + "static/media/zapzap.922272a7.svg";